var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.04 92.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #039;\n      }\n\n      .cls-2 {\n        fill: #00cc87;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.37,61.77h-15.9c-.81,0-1.48.66-1.48,1.48s.66,1.48,1.48,1.48h16.62c-.27-.98-.51-1.96-.72-2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.11,70.48c-.81,0-1.48.66-1.48,1.48s.66,1.48,1.48,1.48h17.54c-.53-.97-1.02-1.95-1.47-2.96H11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.3,32.77l-3.89,4.03c2.77,5.01,4.24,10.67,4.24,16.42,0,18.69-15.21,33.89-33.89,33.89s-33.89-15.21-33.89-33.89,15.21-33.9,33.89-33.9c8.89,0,17.48,3.55,23.8,9.77l4.09-3.53c-7.35-7.41-17.43-11.63-27.89-11.63-21.66,0-39.28,17.62-39.28,39.29,0,.44,0,.88.02,1.31h0c.7,21.06,18.04,37.97,39.26,37.97s39.28-17.62,39.28-39.28c0-7.27-1.98-14.31-5.74-20.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.11,38.61h15.01c.37-1,.78-1.99,1.22-2.96H11.11c-.81,0-1.48.66-1.48,1.48,0,.82.66,1.48,1.48,1.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.51,53.22c0-.05,0-.1,0-.16H1.48c-.82,0-1.48.66-1.48,1.48s.66,1.48,1.48,1.48h22.13c-.06-.93-.09-1.86-.09-2.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.37,32.3l-21.07,18.19c-.54.46-1.33.48-1.88.04l-7.79-6.18-3.9.07,11.03,17.79,25.74-26.66,5.92-6.13.07-.07,6.04-6.25-1.56-1.68-6.19,5.34-.11.09-6.2,5.35-.11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.81,18.33c.3,0,.61-.09.87-.28l3.29-2.4,4.13,5.67c.74-.65,1.51-1.27,2.3-1.86l-4.05-5.55h0s3.29-2.4,3.29-2.4c.66-.48.8-1.4.32-2.06-.48-.66-1.41-.8-2.06-.32l-8.96,6.53c-.66.48-.8,1.4-.32,2.06.29.4.74.61,1.2.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.75,10.98c1.12,0,2.23.04,3.34.13v-4.03h-6.68v4.02c1.1-.09,2.22-.13,3.34-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.19,0h19.12v4.13h-19.12V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.09,41.51l7.02-.13c.33,0,.68.11.95.32l7.24,5.75,19.01-16.42c-5.75-5.58-13.53-8.75-21.56-8.75-17.06,0-30.94,13.88-30.94,30.94s13.88,30.94,30.94,30.94,30.94-13.88,30.94-30.94c0-4.95-1.18-9.82-3.44-14.19l-25.67,26.59c-.28.29-.66.45-1.06.45-.05,0-.11,0-.16,0-.45-.05-.86-.3-1.1-.69l-13.4-21.61c-.28-.45-.3-1.02-.04-1.48.26-.47.74-.76,1.27-.77h0ZM64.28,27.25c0-.81.66-1.48,1.48-1.48s1.48.66,1.48,1.48v2.48c0,.81-.66,1.48-1.48,1.48s-1.48-.66-1.48-1.48v-2.48ZM84.81,64.23c.41-.71,1.31-.95,2.02-.54l2.15,1.24c.71.41.95,1.31.54,2.02-.27.47-.77.74-1.28.74-.25,0-.51-.06-.74-.2l-2.15-1.25c-.71-.41-.95-1.31-.54-2.02h0ZM64.28,76.71c0-.81.66-1.48,1.48-1.48s1.48.66,1.48,1.48v2.49c0,.81-.66,1.48-1.48,1.48s-1.48-.66-1.48-1.48v-2.49ZM46.15,66.24l-2.15,1.25c-.23.14-.49.2-.74.2-.51,0-1.01-.27-1.28-.74-.41-.71-.16-1.61.54-2.02l2.15-1.24c.7-.41,1.61-.17,2.02.54.41.71.17,1.61-.54,2.02h0ZM46.69,42.22c-.27.47-.77.74-1.28.74-.25,0-.5-.06-.74-.2l-2.15-1.24c-.71-.41-.95-1.31-.54-2.02.41-.71,1.31-.95,2.02-.54l2.15,1.25c.71.41.95,1.31.54,2.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.47,47.31h15.46c.14-1,.31-1.98.52-2.95h-15.98c-.81,0-1.48.66-1.48,1.48s.66,1.48,1.48,1.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuick);
export default __webpack_public_path__ + "static/media/quick.98f7fa6a09844bc7459bea18dd19b303.svg";
export { ForwardRef as ReactComponent };